module.exports = __webpack_public_path__ + "static/media/808a25e4-a465-4de6-8c70-37e7f5607f78.bd1ed8d4.jpeg";